import { Apis } from 'Redux/APIs'
import axiosClient from 'Utils/axiosClient'

export const getRvuReport = async (params) => {
  const response = await axiosClient.post(Apis.ProviderRVUReport, params)

  return response.data
}

export const getRvuReportFileName = async (params) => {
  const response = await axiosClient.post(Apis.ExportRVUReport, params)

  return response.data
}
export const downloadRuv = async (params) => {
  const response = await axiosClient.get(
    `${Apis.Production_downloadDetails}?filePath=${encodeURIComponent(params)}`,
    {
      responseType: 'blob',
    },
  )

  return response.data
}
